import Layout from '@/views/Layout/index.vue'
const SalePage = () => import('@/views/SalePage/index.vue')
const All = () => import('@/views/SalePage/All/index.vue')
const Potential = () => import('@/views/SalePage/Potential/index.vue')
const Prospective = () => import('@/views/SalePage/Prospective/index.vue')
const Member = () => import('@/views/SalePage/Member/index.vue')
const PublicPool = () => import('@/views/SalePage/PublicPool/index.vue')
const AuditionRecord = () => import('@/views/SalePage/AuditionRecord/index.vue')
const Order = () => import('@/views/SalePage/Order/index.vue')
const ClueDetail = () => import('@/views/SalePage/ClueDetail/index.vue')
const StudentDetail = () => import('@/views/StudentPage/StudentDetail/index.vue');
const MerchandiseReturn = () => import('@/views/SalePage/Order/MerchandiseOrder/MerchandiseReturn/index.vue');
export default {
  path: '/sale',
  component: Layout,
  children: [
    {
      path: '',
      component: SalePage,
      children: [
        {
          path: '',
          component: All,
        }, {
          path: 'merchandiseReturn',
          component: MerchandiseReturn,
        },
        {
          path: 'potential',
          component: Potential,
        },
        {
          path: 'prospective',
          component: Prospective,
        },
        {
          path: 'member',
          component: Member,
        },
        {
          path: 'publicpool',
          component: PublicPool,
        },
        {
          path: 'studentdetail',
          component: StudentDetail,
        },
        {
          path: 'auditionrecord',
          component: AuditionRecord,
        },
        {
          path: 'order',
          component: Order,
        },
        {
          path: 'cluedetail',
          component: ClueDetail,
        },
      ]
    }
  ]
}
